import React from "react";

export class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error caught", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div data-testid="error-boundary" className="border border-[#EF4444]/40 bg-[#EF4444]/5 px-3 py-3">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#EF4444]">Something went wrong</p>
          <p className="mt-1 break-words font-mono text-[11px] text-zinc-300">{String(this.state.error?.message || this.state.error)}</p>
          <button
            data-testid="error-boundary-reset"
            onClick={() => { this.setState({ error: null }); this.props.onReset?.(); }}
            className="mt-3 border border-[#1F1F1F] px-3 py-1.5 text-xs text-zinc-300 hover:bg-[#111111]"
          >
            Dismiss
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
